import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { apiGet, apiPost } from '../../../API/Api_Url';
import { FaEdit, FaEye, FaPlus, FaTrashAlt, FaUserTie } from 'react-icons/fa';
import { Calendar, CheckCircle, DollarSign, MapPin, Package, Truck, XCircle } from 'lucide-react';
import { toast } from 'react-toastify';

function UserAllSupplierConfirmedMaterialRequest({ RequirementState, setRequirementState }) {

    const [MaterialRequest, setMaterialRequest] = useState([]);
    const [isUploading, setIsUploading] = useState(false);

    const GetUserAllSupplierConfirmedMaterialRequest = async () => {
        try {
            setIsUploading(true);
            const response = await apiGet('api/user/UserGetStatusWiseAllMaterialRequest?status=Confirmed');
            setMaterialRequest(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsUploading(false);
        }
    };

    useEffect(() => {
        GetUserAllSupplierConfirmedMaterialRequest();
    }, []);

    const getStatusColor = (status) => {
        switch (status) {
            case 'Pending':
                return 'bg-yellow-100 text-yellow-800 border-yellow-200';
            case 'Confirmed':
                return 'bg-green-100 text-green-800 border-green-200';
            case 'Rejected':
                return 'bg-red-100 text-red-800 border-red-200';
            default:
                return 'bg-gray-100 text-gray-800 border-gray-200';
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };
    return (
        <div className="p-6 bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen">
            <div className="max-w-7xl mx-auto">
                <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between">
                    <div>
                        <h1 className="text-3xl font-bold text-gray-900 mb-1 md:mb-0">
                            My All Material Requests
                        </h1>
                        <p className="text-gray-600">Manage and track your Material Requests</p>
                    </div>
                    <div className="flex items-center gap-4 mt-4 md:mt-0">
                        <select
                            value={RequirementState}
                            onChange={(e) => setRequirementState(e.target.value)}
                            className="border border-gray-300 rounded-lg px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#0060B9]"
                        >
                            <option value="All">All</option>
                            <option value="pending">Pending</option>
                            <option value="SupplierSelected">Supplier Selected</option>
                            <option value="Confirmed">Supplier Confirmed</option>
                            <option value="InTransit"> Material In Transit</option>
                            <option value="Delivered">Delivered</option>
                            <option value="RejectedAndReturn">Rejected And Return</option>
                            <option value="Completed">Completed</option>
                        </select>
                    </div>

                </div>

                {isUploading ? (
                    <div className="flex items-center justify-center py-20">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                        <p className="ml-4 text-gray-600">Loading your projects...</p>
                    </div>
                ) : MaterialRequest?.length === 0 ? (
                    <div className="text-center py-20">
                        <p className="text-xl text-gray-500">No Material Requests found.</p>
                        <p className="text-gray-400 mt-2">Create your first job post to get started.</p>
                    </div>
                ) : (
                    <div className="grid gap-6 grid-cols-1">
                        {MaterialRequest?.map((req) => (
                            <div key={req?._id} className="bg-white rounded-2xl shadow-lg p-6">
                                <div className="flex justify-between items-start mb-4">
                                    <h3 className="text-xl font-bold text-gray-900">
                                        Material Request #{req?._id?.slice(-6)}
                                    </h3>
                                    <span
                                        className={`px-3 py-1 text-xs font-semibold rounded-full border ${getStatusColor(
                                            req?.Status
                                        )}`}
                                    >
                                        {req?.Status}
                                    </span>
                                </div>
                                {req?.location && (
                                    <div className="flex items-start text-gray-600 mb-4">
                                        <MapPin className="h-4 w-4 mr-2 mt-0.5 text-blue-500" />
                                        <p className="text-sm">
                                            {req?.location?.Address}, {req?.location?.City},{" "}
                                            {req?.location?.State}
                                        </p>
                                    </div>
                                )}
                                <div className="flex items-center text-gray-700 text-sm mb-3">
                                    <Calendar className="h-4 w-4 mr-2 text-orange-500" />
                                    <p>
                                        <span className="font-medium">Delivery Date:</span>{" "}
                                        {formatDate(req?.deliveryDate)}
                                    </p>
                                </div>
                                <div className="mt-4">
                                    <h4 className="font-semibold text-gray-800 mb-2 flex items-center">
                                        <Package className="h-4 w-4 mr-2 text-green-500" />
                                        Material Items
                                    </h4>
                                    <div className="space-y-3">
                                        {req?.MaterialItems?.map((item, i) => (
                                            <div
                                                key={i}
                                                className="bg-gray-50 border border-gray-200 p-4 rounded-xl flex flex-col sm:flex-row sm:items-center justify-between"
                                            >
                                                <div>
                                                    <p className="text-sm font-semibold text-gray-800">
                                                        {item?.materialName}
                                                    </p>
                                                    <p className="text-xs text-gray-500">
                                                        Qty: {item?.quantity} {item?.unit} | Specs:{" "}
                                                        {item?.specifications}
                                                    </p>
                                                    {item?.brandPreference && (
                                                        <p className="text-xs text-blue-600 font-medium mt-1">
                                                            Brand Preference: {item?.brandPreference}
                                                        </p>
                                                    )}
                                                </div>
                                                <div className="flex flex-wrap gap-2 mt-2 sm:mt-0">
                                                    <span className="bg-gray-200 text-gray-700 text-xs px-3 py-1 rounded-full shadow-sm">
                                                        {item?.unit}
                                                    </span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                {req?.SelectedMaterialSupplier && (
                                    <div className="mt-6 border-t pt-4">
                                        <h4 className="font-semibold text-gray-800 mb-2 flex items-center">
                                            <FaUserTie className="h-4 w-4 mr-2 text-purple-500" />
                                            Selected Supplier
                                        </h4>

                                        <div className="bg-gray-50 border border-gray-200 p-4 rounded-xl mb-3">
                                            <p className="text-sm font-semibold text-gray-800">
                                                {req?.SelectedMaterialSupplier?.MaterialSupplier?.companyName}
                                            </p>
                                            <p className="text-xs text-gray-500">
                                                Contact: {req?.SelectedMaterialSupplier?.MaterialSupplier?.contactPerson} (
                                                {req?.SelectedMaterialSupplier?.MaterialSupplier?.phoneNumber})
                                            </p>
                                            <p className="text-xs text-gray-500">
                                                Email: {req?.SelectedMaterialSupplier?.MaterialSupplier?.emailAddress}
                                            </p>
                                        </div>
                                        <h5 className="font-medium text-gray-700 mb-2">Accepted Bid</h5>
                                        <div className="space-y-3">
                                            {req?.SelectedMaterialSupplier?.SelectedBid?.QuotedItems?.map(
                                                (qItem, i) => (
                                                    <div
                                                        key={i}
                                                        className="bg-white border border-gray-200 p-3 rounded-lg shadow-sm flex justify-between items-center"
                                                    >
                                                        <div>
                                                            <p className="text-sm font-semibold text-gray-800">
                                                                {qItem?.materialName}
                                                            </p>
                                                            <p className="text-xs text-gray-500">
                                                                Qty: {qItem?.quantity} {qItem?.unit} | Specs:{" "}
                                                                {qItem?.specifications}
                                                            </p>
                                                            <p className="text-xs text-gray-600">
                                                                Brand: {qItem?.brand}
                                                            </p>
                                                        </div>
                                                        <div className="text-right">
                                                            <p className="text-sm font-semibold text-green-600">
                                                                ₹{qItem?.pricePerUnit} / {qItem?.unit}
                                                            </p>
                                                            <p className="text-xs text-gray-500">
                                                                Total: ₹{qItem?.totalPrice}
                                                            </p>
                                                        </div>
                                                    </div>
                                                )
                                            )}
                                        </div>
                                        <div className="mt-4 text-sm text-gray-600 space-y-1">
                                            <p>GST: {req?.SelectedMaterialSupplier?.SelectedBid?.GST}%</p>
                                            <p>
                                                Delivery Time:{" "}
                                                {req?.SelectedMaterialSupplier?.SelectedBid?.DeliveryTime}
                                            </p>
                                            <p>
                                                Credit Terms:{" "}
                                                {req?.SelectedMaterialSupplier?.SelectedBid?.CreditTerms}
                                            </p>
                                            <p>
                                                Note: {req?.SelectedMaterialSupplier?.SelectedBid?.Note}
                                            </p>
                                            <p className="font-semibold text-gray-800">
                                                Grand Total: ₹{req?.SelectedMaterialSupplier?.TotalPrice}
                                            </p>
                                        </div>
                                    </div>
                                )}
                                <div className="mt-4 flex justify-between items-center text-sm text-gray-500">
                                    <span className="flex items-center">
                                        <Calendar className="h-4 w-4 mr-1" />
                                        Created: {formatDate(req?.createdAt)}
                                    </span>
                                    <div className="flex items-center gap-2">
                                        <button className="flex items-center gap-1 px-3 py-1 text-sm bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition">
                                            <FaEye className="h-4 w-4" /> View Details
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                )}
            </div>
        </div>
    )
}

export default UserAllSupplierConfirmedMaterialRequest